// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"3d25708a","315":"8885a93e","330":"1b95c31a","351":"4bd801ef","353":"b1b3381b","393":"1d850753","450":"a4044e17","476":"8c557c3f","681":"78e94f84","741":"b5d2e0a7","786":"f96d5155","806":"55e27d21","958":"1313bcbe"}[chunkId] + ".chunk.js";
};